<template>
  <div class="forum">
    <div class="container">
      <div class="sidebar">
        <div class="search-box">
          <input type="text" placeholder="搜索论坛话题..." class="search-input" v-model="searchQuery">
          <button class="search-btn" @click="handleSearch">搜索</button>
        </div>
        <div class="category-list">
          <h3>论坛分类</h3>
          <ul>
            <li class="category-item" :class="{ active: selectedCategory === '全部' }" @click="selectCategory('全部')">全部</li>
            <li class="category-item" :class="{ active: selectedCategory === '指标交流' }" @click="selectCategory('指标交流')">指标交流</li>
            <li class="category-item" :class="{ active: selectedCategory === '股市讨论' }" @click="selectCategory('股市讨论')">股市讨论</li>
            <li class="category-item" :class="{ active: selectedCategory === '软件求助' }" @click="selectCategory('软件求助')">软件求助</li>
            <li class="category-item" :class="{ active: selectedCategory === '经验分享' }" @click="selectCategory('经验分享')">经验分享</li>
          </ul>
        </div>
      </div>
      <div class="content">
        <div class="page-header">
          <h1>交流论坛</h1>
          <p>分享经验，交流心得，共同进步</p>
        </div>
        <div class="post-list">
          <div class="post-item" v-for="post in filteredPosts" :key="post.id">
            <div class="post-header">
              <h2 class="post-title"><router-link :to="{ name: 'post', params: { id: post.id } }" class="post-link">{{ post.title }}</router-link></h2>
              <span class="post-tag">{{ post.tag }}</span>
            </div>
            <div class="post-content">
              {{ post.content }}
            </div>
            <div class="post-meta">
              <span class="post-author">{{ post.author }}</span>
              <span class="post-time">{{ post.time }}</span>
              <span class="post-replies">{{ post.replies }} 回复</span>
              <span class="post-views">{{ post.views }} 浏览</span>
            </div>
          </div>
        </div>
        <div class="pagination">
          <button class="page-btn">上一页</button>
          <button class="page-btn active">1</button>
          <button class="page-btn">2</button>
          <button class="page-btn">3</button>
          <button class="page-btn">下一页</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ForumView',
  data() {
    return {
      searchQuery: '',
      selectedCategory: '全部',
      posts: [
        {
          id: 11,
          title: '【指标交流】分享一个我用了5年的MACD优化指标',
          tag: '指标交流',
          content: '这个MACD优化指标是我根据多年的实战经验修改的，比原版MACD更敏感，能更早捕捉到趋势变化...',
          author: '股海沉浮',
          time: '今天 09:30',
          replies: '23',
          views: '156'
        },
        {
          id: 12,
          title: '【股市讨论】当前市场行情分析与操作策略',
          tag: '股市讨论',
          content: '近期市场波动较大，大家对后市怎么看？我认为短期可能会有调整，但长期依然看好科技板块...',
          author: '趋势为王',
          time: '昨天 14:25',
          replies: '45',
          views: '328'
        },
        {
          id: 13,
          title: '【软件求助】通达信软件无法导入指标，求大神帮忙',
          tag: '软件求助',
          content: '最近下载了一个指标，但是在通达信中无法导入，总是提示格式错误，有谁知道怎么解决吗？...',
          author: '新手小白',
          time: '2天前',
          replies: '18',
          views: '215'
        },
        {
          id: 14,
          title: '【经验分享】我的短线交易心得，成功率80%以上',
          tag: '经验分享',
          content: '做短线交易多年，总结了一些心得，今天分享给大家，希望对大家有所帮助...',
          author: '短线高手',
          time: '3天前',
          replies: '56',
          views: '489'
        },
        {
          id: 15,
          title: '【指标交流】求一个通达信成交量指标，能显示主力资金流向',
          tag: '指标交流',
          content: '想找一个能显示主力资金流向的成交量指标，最好是通达信的，有哪位大神能分享一下吗？...',
          author: '资金追踪',
          time: '1周前',
          replies: '32',
          views: '276'
        }
      ]
    }
  },
  computed: {
    filteredPosts() {
      let result = [...this.posts];
      
      // 分类筛选
      if (this.selectedCategory !== '全部') {
        result = result.filter(post => post.tag === this.selectedCategory);
      }
      
      // 搜索筛选
      if (this.searchQuery) {
        const query = this.searchQuery.toLowerCase();
        result = result.filter(post => 
          post.title.toLowerCase().includes(query) || 
          post.content.toLowerCase().includes(query)
        );
      }
      
      return result;
    }
  },
  methods: {
    selectCategory(category) {
      this.selectedCategory = category;
    },
    handleSearch() {
      // 搜索逻辑已在computed中处理
    }
  }
}
</script>

<style lang="scss" scoped>
.forum {
  padding: 20px 0;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  gap: 30px;
}

.sidebar {
  width: 250px;
  flex-shrink: 0;
}

.search-box {
  display: flex;
  margin-bottom: 30px;
  .search-input {
    flex: 1;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 4px 0 0 4px;
    outline: none;
    &:focus {
      border-color: #1890ff;
    }
  }
  .search-btn {
    padding: 0 15px;
    background-color: #1890ff;
    color: #fff;
    border: none;
    border-radius: 0 4px 4px 0;
    cursor: pointer;
    &:hover {
      background-color: #40a9ff;
    }
  }
}

.category-list {
  h3 {
    font-size: 18px;
    margin-bottom: 15px;
    color: #333;
  }
  ul {
    list-style: none;
  }
  .category-item {
    padding: 10px 15px;
    margin-bottom: 5px;
    background-color: #f5f5f5;
    border-radius: 4px;
    cursor: pointer;
    &:hover {
      background-color: #e6f7ff;
    }
    &.active {
      background-color: #1890ff;
      color: #fff;
    }
  }
}

.content {
  flex: 1;
}

.page-header {
  margin-bottom: 30px;
  h1 {
    font-size: 28px;
    font-weight: 600;
    color: #333;
    margin-bottom: 10px;
  }
  p {
    font-size: 16px;
    color: #666;
  }
}

.post-list {
  margin-bottom: 30px;
}

.post-item {
  background-color: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
}

.post-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 15px;
}

.post-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  flex: 1;
  margin-right: 15px;
  line-height: 1.4;
  .post-link {
    color: #333;
    text-decoration: none;
    &:hover {
      color: #1890ff;
      text-decoration: underline;
    }
  }
}

.post-tag {
  padding: 4px 12px;
  background-color: #f0f0f0;
  border-radius: 12px;
  font-size: 12px;
  color: #666;
  white-space: nowrap;
}

.post-content {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 15px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.post-meta {
  display: flex;
  gap: 20px;
  font-size: 12px;
  color: #999;
  flex-wrap: wrap;
}

.post-author {
  font-weight: 500;
  color: #1890ff;
}

.pagination {
  display: flex;
  justify-content: center;
  gap: 10px;
}

.page-btn {
  padding: 8px 16px;
  border: 1px solid #e8e8e8;
  background-color: #fff;
  border-radius: 4px;
  cursor: pointer;
  &:hover {
    border-color: #1890ff;
    color: #1890ff;
  }
  &.active {
    background-color: #1890ff;
    color: #fff;
    border-color: #1890ff;
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .container {
    flex-direction: column;
    gap: 20px;
  }
  
  .sidebar {
    width: 100%;
  }
  
  .search-box {
    margin-bottom: 20px;
  }
  
  .category-list {
    h3 {
      font-size: 16px;
      margin-bottom: 10px;
    }
    ul {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
    }
    .category-item {
      margin-bottom: 0;
      white-space: nowrap;
    }
  }
  
  .page-header {
    h1 {
      font-size: 24px;
    }
    p {
      font-size: 14px;
    }
  }
  
  .post-item {
    padding: 15px;
    margin-bottom: 15px;
  }
  
  .post-title {
    font-size: 16px;
  }
  
  .post-content {
    font-size: 13px;
  }
  
  .post-meta {
    gap: 15px;
    font-size: 11px;
  }
}

@media (max-width: 480px) {
  .forum {
    padding: 10px 0;
  }
  
  .post-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
  
  .post-tag {
    align-self: flex-start;
  }
  
  .post-meta {
    flex-direction: column;
    gap: 5px;
  }
  
  .page-btn {
    padding: 6px 12px;
    font-size: 14px;
  }
}
</style>